import React from "react";
import moment from "moment";
import "./ValidDatosForm.css";

const ValidDatosForm = ({ usuario, proveedor }) => {
  return (
    <div
      className="validDatosFormDiv"
      style={{ height: window.innerHeight - 250 }}
    >
      <div className="validDatosHeader">
        <div className="customerTitle">
          <h5>
            {proveedor.nroCta} - {proveedor.nombre}
          </h5>
        </div>
        <div className="customerData">
          <span className="spanValidDatos">
            C.U.I.T: <h5>{usuario.userName}</h5>
          </span>
          <span className="spanValidDatos inline">
            C.B.U: <h5>{proveedor.cbu}</h5>
          </span>
        </div>
        <div className="customerInfo">
          <span className="spanValidDatos">
            I.V.A: <h5>{proveedor.condicionIvaDescrp}</h5>
          </span>
        </div>
        <div className="customerInfo">
          <span className="spanValidDatos">
            Dirección: <h5>{proveedor.direcc}&nbsp;&nbsp;&nbsp;</h5>
            <h5>
              {proveedor.codigoPostal}&nbsp;({proveedor.codigoPostalDescrp}
              )&nbsp;&nbsp;&nbsp;
            </h5>{" "}
            <h5>
              {proveedor.pais}&nbsp;({proveedor.paisDescrp})
            </h5>
          </span>
        </div>
        <div className="customerData">
          <span className="spanValidDatos">
            Tel: <h5>{proveedor.telefono}</h5>
          </span>
          <span className="spanValidDatos inline">
            Email: <h5>{proveedor.direml}</h5>
          </span>
        </div>
      </div>


        <div className="validDatosBody">
          <div className="customerExencionesTitle">
            <h3>Certificados:</h3>
          </div>
          {proveedor.exenciones && proveedor.exenciones.length > 0 ? 
          (proveedor.exenciones.map((exencion, index) => (
            <div key={index}>
              <div className="containerExenciones">
                <div className="customerExencionesData">
                  <span className="spanValidDatos">
                    Descripción: <h5>{exencion.tipRetDescrp}</h5>
                  </span>
                </div>
                <div className="customerExencionesData">
                  <span className="spanValidDatos">
                    Porcentaje de exención: <h5>{exencion.pctExn}</h5>
                  </span>
                  <span className="spanValidDatos inline">
                    Porcentaje de reducción: <h5>{exencion.pctRed}</h5>
                  </span>
                </div>
                {exencion.vigenc == true && (
                  <div className="customerExencionesData">
                    <span className="spanValidDatos">
                      Desde:{" "}
                      <h5>{moment(exencion.fecDesRet).format("DD-MM-YYYY")}</h5>
                    </span>
                    <span className="spanValidDatos inline">
                      Hasta:{" "}
                      <h5>{moment(exencion.fecHasRet).format("DD-MM-YYYY")}</h5>
                    </span>
                  </div>
                )}
              </div>
              {index < proveedor.exenciones.length - 1 && <hr className="hr" />}
            </div>
          )))
          :(
            <div><p style={{fontSize: "22px"}}>No hay exenciones para mostrar.</p></div>
          )
          }
        </div>
    </div>
  );
};

export default ValidDatosForm;